<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title1">
      {{title}}
    </h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
  </div>

  <div class="modal-body" >

    <div class="col-8">
      <div class="mb-3 row">
        <label class="col-md-5 col-form-label">
          <div>Old Password</div>
        </label>
        <div class="col-md-7">
          <input type="password" formControlName="oldPassword" class="form-control"
                        [ngClass]="{'is-invalid': submitted &&  f.oldPassword.errors
                    }" required  autocomplete="off"/>
            @if (submitted && f.oldPassword.errors) {
              <div class="invalid-feedback">
                @if (f.oldPassword.errors.required) {
                  <div>Old password is required</div>
                }
                @if (f.oldPassword.errors.minlength) {
                  <div>Min 8 character</div>
                }
              </div>
            }

          </div>

        </div>
      </div>
      <div class="col-8">
        <div class="mb-3 row">
          <label class="col-md-5 col-form-label">
            <div>New Password</div>
          </label>

          <div class="col-md-7">
            <input type="password" formControlName="newPassword" class="form-control"
                        [ngClass]="{'is-invalid': submitted &&  f.newPassword.errors
                    }" required />
              @if (submitted && f.newPassword.errors) {
                <div class="invalid-feedback">
                  @if (f.newPassword.errors.required) {
                    <div>New password is required</div>
                  }
                  @if (f.newPassword.errors.minlength) {
                    <div>Min 8 character</div>
                  }
                </div>
              }

            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalRef.hide()">Cancel</button>
        <button type="submit" class="btn btn-primary">Submit</button>
      </div>
    </form>